export default "__VITE_ASSET__C30MEFcw__"